import * as yup from 'yup';

/**
 * Max file size in MB
 */
export const MAX_FILE_SIZE = 100;

/**
 * For files with names with an higher number of chars -> truncate with ellipses in the middle
 */
export const TRUNCATE_FILE_NAME_THRESHOLD = 40;

export const validation = yup.array().of(
  yup.object().shape({
    name: yup.string().required('This field is required.'),
  }),
);
